import useModal from 'hook/useModal'

import { Image, Tag, Text } from 'components'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'
import { formatNumberComma } from 'utils/format-util'
// css
import 'assets/style/elements/menu-list.scss'
import { useEffect, useState } from 'react'
import { combineImages } from 'utils/image-mark'

function MenuList({ className, datas = [], isDispImg = true, isStore = true }) {
  const { openMenuRecip } = useModal()
  const userInfo = useRecoilValue(userInfoState)
  const isPriceVisible = (siteId) => {
    return (
      !userInfo.phbtUseSiteList?.includes(siteId) ||
      (userInfo.phbtUseUser === true &&
        userInfo.phbtUseSiteList?.includes(siteId) &&
        userInfo.phbtUseUserShpt === siteId?.substring(0, 3))
    )
  }
  const [imgUrls, setImgUrls] = useState({})

  useEffect(() => {
    const lists = datas || []
    if (!Array.isArray(lists) || lists.length === 0) return

    let cancelled = false

    const run = async () => {
      const nextImgUrls = {}

      for (const item of lists) {
        if (!item.src) continue

        const originUrl = process.env.REACT_APP_PRODUCT_MENU_IMAGE_URL + '/' + item.src

        if (item?.aiImgYn === 'Y') {
          try {
            const watermarkUrl = await combineImages(originUrl, 'Y', true, false, item?.moveYn || false)

            if (!cancelled && watermarkUrl) {
              nextImgUrls[`${item.menuId}_${item.menuSeq}`] = watermarkUrl
            }
          } catch (e) {
            nextImgUrls[`${item.menuId}_${item.menuSeq}`] = originUrl
          }
        } else {
          nextImgUrls[`${item.menuId}_${item.menuSeq}`] = originUrl
        }
      }

      if (!cancelled) {
        setImgUrls((prev) => ({
          ...prev,
          ...nextImgUrls,
        }))
      }
    }

    run()

    return () => {
      cancelled = true
      setImgUrls({})
    }
  }, [datas])

  return (
    <>
      <ul className={'menu-list ' + className}>
        {datas.map((item, index) => {
          const { menuId, menuNm, src, badge, trfUnprc, siteId, siteNm, alt, tags, aiImgYn } = item
          return (
            <li
              key={`menu_${index}`}
              onClick={() => {
                openMenuRecip({
                  siteId: item.siteId ? item.siteId : userInfo.siteId,
                  menuId: item.menuId,
                  menuSeq: item.menuSeq ? item.menuSeq : 0,
                  coId: userInfo.coId,
                  userId: userInfo.userId,
                  mySiteId: userInfo.siteId,
                  trmCd: new Date().getDate() <= 15 ? '1' : '2',
                })
              }}
            >
              {isDispImg && (
                <div className="img-wrap border-radius-4 over-hidden">
                  <Image
                    src={imgUrls[`${menuId}_${item.menuSeq}`] || ''}
                    alt={alt}
                    className="thumb"
                    cTTL={true}
                    watermarkYn={aiImgYn === 'Y' ? true : false}
                  />
                  {badge && <span className={`badge ${badge.color}`}>{badge.name}</span>}
                </div>
              )}
              <div className="ml12 flex-1">
                {siteNm && (
                  <div className="tags mb8">
                    <span className="tag green">{siteNm}</span>
                  </div>
                )}
                <div className="flex-1">
                  {tags?.length > 0 && <Tag className="mb8" data={tags} />}
                  <p className="f-medium">
                    [{menuId}]{menuNm}
                  </p>
                </div>
                <div className="txt-price mt4">
                  <Text className="price">
                    {isPriceVisible(siteId) ? (
                      <>
                        <b>{formatNumberComma(trfUnprc || 0)}</b>
                        <span className="ml2">원{isStore ? '/점포가' : ''}</span>
                      </>
                    ) : (
                      <>
                        <b style={{ height: 30 }}></b>
                        <span className="ml2"></span>
                      </>
                    )}
                  </Text>
                </div>
              </div>
            </li>
          )
        })}
      </ul>
    </>
  )
}

export default MenuList
